export const messages = {
  en: {
    editEquipmentAccount: {
      title: 'Edit Equipment',
      machineName: 'Equipment Name',
      machineNamePlaceholder: 'Required, please enter equipment name',
      machineCode: 'Equipment Code',
      machineCodePlaceholder: 'Required, please enter equipment code',
      importanceLevel: 'Importance Level',
      importanceLevelPlaceholder: 'Required, please select importance level',
      state: 'Status',
      statePlaceholder: 'Required, please select status',
      brand: 'Brand',
      brandPlaceholder: 'Optional, please enter brand',
      model: 'Model',
      modelPlaceholder: 'Optional, please enter model',
      netWorth: 'Net Worth',
      netWorthPlaceholder: 'Optional, please enter net worth',
      locationDetail: 'Location Detail',
      locationDetailPlaceholder: 'Optional, please enter location detail',
      firstEnableTime: 'First Enable Time',
      firstEnableTimePlaceholder: 'Optional, please select first enable time',
      warrantyDeadline: 'Warranty Deadline',
      warrantyDeadlinePlaceholder: 'Optional, please select warranty deadline',
      usefulLife: 'Useful Life (Years)',
      usefulLifePlaceholder: 'Optional, please enter useful life',
      purchasePrice: 'Purchase Price',
      purchasePricePlaceholder: 'Optional, please enter purchase price',
      useUserName: 'User',
      useUserNamePlaceholder: 'Required, please select user',
      chargeUseName: 'Responsible Person',
      chargeUseNamePlaceholder: 'Required, please select responsible person',
      remark: 'Remark',
      remarkPlaceholder: 'Optional, please enter remark'
    }
  },
  zh: {
    editEquipmentAccount: {
      title: '修改设备',
      machineName: '设备名称',
      machineNamePlaceholder: '必填，请填写设备名称',
      machineCode: '设备编码',
      machineCodePlaceholder: '必填，请填写设备编码',
      importanceLevel: '重要等级',
      importanceLevelPlaceholder: '必填，请选择重要等级',
      state: '使用状态',
      statePlaceholder: '必填，请选择使用状态',
      brand: '设备品牌',
      brandPlaceholder: '选填，请填写设备品牌',
      model: '设备型号',
      modelPlaceholder: '选填，请填写设备型号',
      netWorth: '资产净值',
      netWorthPlaceholder: '选填，请填写资产净值',
      locationDetail: '位置详情',
      locationDetailPlaceholder: '选填，请填写位置详情',
      firstEnableTime: '首次启用时间',
      firstEnableTimePlaceholder: '选填，请填写首次启用时间',
      warrantyDeadline: '保修截止日期',
      warrantyDeadlinePlaceholder: '选填，请填写保修截止日期',
      usefulLife: '使用年限(年)',
      usefulLifePlaceholder: '选填，请填写使用年限',
      purchasePrice: '采购价格',
      purchasePricePlaceholder: '选填，请填写采购价格',
      useUserName: '使用人',
      useUserNamePlaceholder: '必填，请选择使用人',
      chargeUseName: '责任人',
      chargeUseNamePlaceholder: '必填，请选择责任人',
      remark: '备注',
remarkPlaceholder: '选填，请填写备注'
    }
  },
  'zh-TW': {
    editEquipmentAccount: {
      title: '修改設備',
      machineName: '設備名稱',
      machineNamePlaceholder: '必填，請填寫設備名稱',
      machineCode: '設備編碼',
      machineCodePlaceholder: '必填，請填寫設備編碼',
      importanceLevel: '重要等級',
      importanceLevelPlaceholder: '必填，請選擇重要等級',
      state: '使用狀態',
      statePlaceholder: '必填，請選擇使用狀態',
      brand: '設備品牌',
      brandPlaceholder: '選填，請填寫設備品牌',
      model: '設備型號',
      modelPlaceholder: '選填，請填寫設備型號',
      netWorth: '資產淨值',
      netWorthPlaceholder: '選填，請填寫資產淨值',
      locationDetail: '位置詳情',
      locationDetailPlaceholder: '選填，請填寫位置詳情',
      firstEnableTime: '首次啟用時間',
      firstEnableTimePlaceholder: '選填，請填寫首次啟用時間',
      warrantyDeadline: '保修截止日期',
      warrantyDeadlinePlaceholder: '選填，請填寫保修截止日期',
      usefulLife: '使用年限(年)',
      usefulLifePlaceholder: '選填，請填寫使用年限',
      purchasePrice: '採購價格',
      purchasePricePlaceholder: '選填，請填寫採購價格',
      useUserName: '使用人',
      useUserNamePlaceholder: '必填，請選擇使用人',
      chargeUseName: '責任人',
      chargeUseNamePlaceholder: '必填，請選擇責任人',
      remark: '備註',
      remarkPlaceholder: '選填，請填寫備註'
    }
  }
}